<button (click)="onButtonClicked()" mat-button [class]="btnStyle" [disabled]="disabled" type="button">{{btnContent}}</button>